<template>
  <div>
    <DocumentMenu></DocumentMenu>
    <DocumentContent :type="type" :device="device"></DocumentContent>
    <DocumentLoading v-if="isLoading"></DocumentLoading>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DocumentMenu from "./DocumentMenu.vue";
import DocumentContent from "./DocumentContent.vue";
import DocumentLoading from "./DocumentLoading.vue";

export default {
  name: "DocumentBody",
  props: {
    type: String,
    device: String
  },
  components: {
    DocumentMenu,
    DocumentContent,
    DocumentLoading
  },
  computed: {
    ...mapState({
      isLoading: state => state.document.isLoading,
      menus: state => state.document.menus,
      content: state => state.document.content
    })
  }
};
</script>
